const roleTypes = {
    Viewer: 'Viewer',
    Manager: 'Manager',
    Admin: 'Admin',
    SuperUser: 'SuperUser'
};

export default roleTypes;